module.exports = __webpack_public_path__ + "static/media/summer school.6cf10cf7.jpeg";